export default __webpack_public_path__ + "static/media/logo_image.fad14aff.png";